<app-navbar></app-navbar>

<div class="stats-container">
  <h1>Mes documents PowerBI</h1><h2>{{agencies.length}} document(s) trouvé(s).</h2>
  <div class="row">
    <div *ngFor="let agency of agencies" class="col-md-4 col-xs-12 box">
      <p>{{ agency.name }}</p>
      <button (click)="openIframe(agency.powerbiLink)">Afficher</button>
    </div>
  </div>
</div>

<div class="iframe" *ngIf="iframeOpened">
  <iframe [src]="iframeSrc | safe">
  </iframe>
  <button (click)="iframeOpened = false">Fermer</button>
</div>
